<template>
  <v-snackbar
    ref="snackbar"
    v-model="visible"
    :timeout="msg.timeout"
    :color="msg.color"
    :multi-line="msg.modo === 'multi-line'"
    :vertical="msg.modo === 'vertical'"
    top
    right
  >
    <div v-html="msg.text"/>
    <v-btn dark text @click.native="visible = false">Cerrar</v-btn>
  </v-snackbar>
</template>

<style>
  .v-snack {
    z-index: 9999999 !important;
  }
</style>

<script>
export default {
  data: () => ({
    notifications: [],
    visible: false,
    visibleAt: null,
    minTimeout: 1000,
    activeTimeout: null,
    defaultMsg: {
      modo: 'multi-line',
      timeout: 6000,
      color: 'success',
      text: ''
    },
    msg: {}
  }),

  watch: {
    visible() {
      if (this.visible) {
        this.visibleAt = Date.now();
      } else {
        setTimeout(this.showNext.bind(this), 100);
      }
    },
  },

  mounted() {
    this.$store.registerModule('notifier', {
      state: {
        notifications: []
      },
      mutations: {
        'clear-notifications': state => state.notifications = [],
        'notification': (state, msg) => {
          const m = typeof msg === 'string' ? {text: msg} : msg;
          state.notifications.push(m);
        },
        'success-notification': (state, msg) => {
          const m = typeof msg === 'string' ? {text: msg} : msg;
          m.color = 'success';
          state.notifications.push(m);
        },
        'error-notification': (state, msg) => {
          const m = typeof msg === 'string' ? {text: msg} : msg;
          m.color = 'error';
          state.notifications.push(m);
        }
      }
    });

    this.$store.watch(state => state.notifier.notifications, (notifications) => {
      if (notifications.length) {
        this.notifications.push(...notifications);
        this.$store.commit('clear-notifications');
        this.showNext();
      }
    });
  },

  methods: {
    showNext() {
      if (!this.notifications.length) {
        return;
      }

      if (!this.visible) {
        const msg = this.notifications.shift();
        const timeout = this.notifications.length > 0 ? this.minTimeout : this.defaultMsg.timeout;
        this.msg = Object.assign({}, this.defaultMsg, {timeout}, msg);
        this.visible = true;
        return;
      }

      // si esta visible y cumplio el tiempo minimo, entonces cerrar
      const newTimeout = (this.visibleAt + this.minTimeout) - Date.now();
      if (newTimeout <= 0) {
        this.visible = false;
        return;
      }

      // esta visible, aun no cumple el tiempo minimo, y aun no se le modifica su timeout
      if (this.msg.timeout > this.minTimeout) {
        this.msg.timeout = newTimeout;
        setTimeout(() => this.$refs.snackbar.setTimeout());
        return;
      }
    }
  },

};
</script>
